// extracted by mini-css-extract-plugin
export default {"select":"MultiSelect_select__ySpTE","error":"MultiSelect_error__sEYn5"};